import React, { FC, useCallback, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import VaultStatsTiles from '../../components/VaultStatsTiles/VaultStatsTiles';
import VaultsList from '../../components/VaultsList/VaultsList';
import MyVaultsEmpty from '../../components/MyVaultsEmpty/MyVaultsEmpty';
import Tabs from '../../components/common/Tabs/Tabs';

import { useUserContext } from '../../contexts/UserContext';

import styles from './VaultsPage.module.scss';

export interface VaultsPageProps {
  vaultsLoaded: boolean;
  vaults: any;
  vaultsToDisplay: any[];
  myVaults: any[];
  addyData: any;
  onConnectWallet: () => void;
}

const VaultsPage: FC<VaultsPageProps> = ({
  vaults,
  vaultsToDisplay,
  myVaults,
  vaultsLoaded,
  addyData,
  onConnectWallet,
}) => {
  const [currentVaultsTab, setCurrentVaultsTab] = useState(0);
  const { isWalletConnected, account } = useUserContext();

  const handleGoToVaults = useCallback(() => {
    setCurrentVaultsTab(0);
  }, []);

  return (
    <>
      <div className={styles.statsTiles}>
        <VaultStatsTiles account={account} addyData={addyData} vaults={vaults} />
      </div>

      <div className={styles.vaultsList}>
        <AnimatePresence exitBeforeEnter>
          {vaultsLoaded && (
            <motion.div key={0} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <Tabs
                currentTab={currentVaultsTab}
                tabs={['All', `My Vaults${isWalletConnected ? ` (${myVaults.length})` : ''}`]}
                onTabChange={setCurrentVaultsTab}
                className={styles.vaultsTabs}
              />
              {currentVaultsTab === 0 && <VaultsList vaults={vaultsToDisplay} />}
              {currentVaultsTab === 1 && (myVaults.length === 0 || !isWalletConnected) && (
                <MyVaultsEmpty
                  isWalletConnected={isWalletConnected}
                  onConnectWallet={onConnectWallet}
                  onGoToVaults={handleGoToVaults}
                />
              )}
              {currentVaultsTab === 1 && myVaults.length > 0 && <VaultsList vaults={myVaults} />}
            </motion.div>
          )}

          {!vaultsLoaded && (
            <motion.div key={1} initial={{ opacity: 1 }} exit={{ opacity: 0 }}>
              <div className={styles.loaderContainer}>Loading Vaults...</div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default VaultsPage;
